import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AdminMenu from './AdminMenu';
import { useAuthentication } from '@/features/auth/useAuthentication';

interface AdminLayoutProps {
  children: React.ReactNode;
  title?: string;
}

const AdminLayout: React.FC<AdminLayoutProps> = ({ children, title }) => {
  const navigate = useNavigate();
  const { loggedUser, authenticationDone, checkAuthentication, isGlobalAdmin } = useAuthentication();

  useEffect(() => {
    if (!authenticationDone) {
      checkAuthentication();
    }
  }, [authenticationDone, checkAuthentication]);

  useEffect(() => {
    if (authenticationDone && (!loggedUser || !isGlobalAdmin())) {
      navigate('/login', { replace: true });
    }
  }, [authenticationDone, loggedUser, isGlobalAdmin, navigate]);

  if (!authenticationDone || !loggedUser || !isGlobalAdmin()) {
    return null;
  }

  return (
    <div className="min-h-screen bg-gray-100">
      {/* Admin Header */}
      <header className="bg-white shadow-sm border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-4">
            <div className="flex items-center">
              <h1 className="text-2xl font-bold text-gray-900">
                {title || 'Admin Dashboard'}
              </h1>
            </div>
            <div className="flex items-center space-x-4">
              {/* User menu placeholder */}
              <div className="flex items-center space-x-2">
                <div className="w-8 h-8 bg-blue-500 rounded-full flex items-center justify-center">
                  <span className="text-white text-sm font-medium">A</span>
                </div>
                <span className="text-gray-700">Administrator</span>
              </div>
            </div>
          </div>
        </div>
      </header>

      <div className="flex">
        {/* Sidebar */}
        <AdminMenu />
        
        {/* Main Content */}
        <main className="flex-1 p-6">
          {children}
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
